import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import {
  configFilterDuration,
  configFilterPrices,
  configFilterTimeSlots,
} from '../filterConfigs';

import Button, { ButtonSizes, ButtonStyles } from '../../Button/Button';
import BetaIcon, { IconSizes } from '../../Icons/Icon';
import Image, { ImageSizes } from '../../../ui-components/Image/Image';
import Typography from '../../../ui-components/Typography/Typography';
import { TRANSLATIONS } from '../../../../translations';
import { configDistanceLimit } from '../filterConfigs';
import { useState, useEffect } from 'react';
import iconChevronUp from '@iconify-icons/mdi/chevron-up';
import iconChevronDown from '@iconify-icons/mdi/chevron-down';
import { Icon } from '@iconify/react';

const AllFiltersSelectedFilter = ({
  params,
  filtersKeys,
  history,
  resetFilters,
  tags,
  categories,
  filterContents,
  dateSpanString = null,
  flashSkeletons,
}) => {
  const updateFilterObject = (filterObject, value) => {
    const updatedFilterObject = { ...filterObject, value };
    getFilterObjectTitle(updatedFilterObject);
    filtersData.push(updatedFilterObject);
  };

  const findSubCategoryItemById = (id) => {
    for (let i = 0; i < categories.length; i++) {
      const item = categories[i];
      if (item.id === id) {
        return { item, index: i };
      }
      if (item.categories) {
        for (let j = 0; j < item.categories.length; j++) {
          const subItem = item.categories[j];
          if (subItem.id === id) {
            return { item: item, subItem: subItem };
          }
        }
      }
    }
    return null;
  };

  const getFilterObjectTitle = (filterData) => {
    switch (filterData.key) {
      case 'price':
        {
          const priceId = parseInt(filterData.value);
          const price = configFilterPrices.filter((c) => c.id === priceId);
          filterData.title = `${TRANSLATIONS.PRICE}: ${price[0]?.title}`;
        }
        break;
      case 'price_span': {
        filterData.title = `${TRANSLATIONS.PRICE}: ${filterData.value}€`;
        break;
      }
      case 'distance': {
        filterData.title = `${TRANSLATIONS.DISTANCE}: ${filterData.value} km`;
        break;
      }
      case 'min_age': {
        const string_info = filterData.value != 1 ? 'YEARS' : 'YEAR';
        filterData.title = `${TRANSLATIONS.MIN_AGE}: ${filterData.value} ${TRANSLATIONS[string_info]}`;
        break;
      }
      case 'participants': {
        const participants = filterData.value;
        filterData.title = `${TRANSLATIONS.N_PARTICIPANTS}: ${participants}`;
        break;
      }
      case 'duration': {
        const durationId = parseInt(filterData.value[0]);
        const duration = configFilterDuration.filter(
          (c) => c.id === durationId
        );
        filterData.title = `${TRANSLATIONS.SPAN}: ${duration[0]?.title}`;
        break;
      }
      case 'time_slots': {
        const timeSlotId = parseInt(filterData.value[0]);
        const timeSlot = configFilterTimeSlots.filter(
          (c) => c.id === timeSlotId
        );
        filterData.title = `${TRANSLATIONS.TIME}: ${timeSlot[0]?.title}`;
        break;
      }
      case 'category': {
        const categoryId = parseInt(filterData.value);
        const category = findSubCategoryItemById(categoryId);
        filterData.title = `${category && category.subItem
          ? category.subItem.title
          : category?.item?.title
          }`;
        break;
      }
      case 'tag': {
        const tagId = parseInt(filterData.value[0]);
        const tag = tags.filter((c) => c.id === tagId);
        filterData.title = `${tag[0]?.title}`;
        break;
      }
      case 'poi': {
        const key = 'poi';
        const poiId = parseInt(filterData.value);
        const poi = filterContents[key].filter((c) => c.id === poiId);
        filterData.title = `${poi[0]?.title}`;
        break;
      }
      case 'city': {
        const key = 'city';
        const cityId = filterData.value;
        const city = filterContents[key].filter((c) => c.id === cityId);
        filterData.title = `${city[0]?.title}`;
        break;
      }
      default:
      // console.warn(
      //   'getFilterDataTitle => unhandled filter key: ' + filterData.key
      // );
    }
  };

  // const paramsArr = Object.keys(params).map((param) => ({
  //   [param]: params[param],
  // }));
  // const paramKeys = Object.keys(params);
  // const matchingKeys = filtersKeys.filter((key) => paramKeys.includes(key));
  // console.log(matchingKeys);

  const filtersData = [];
  Object.entries(params).forEach((param) => {
    const [paramKey, paramValues] = param;

    filtersKeys.forEach((filterKey) => {
      if (filterKey !== paramKey || paramValues === '') return;

      const filterObject = {
        key: filterKey,
        param: param,
      };

      //price array in search
      if (Array.isArray(paramValues) && paramKey === 'price_span') {
        updateFilterObject(filterObject, paramValues.join(' - '));
        return;
      }

      if (paramKey === 'distance') {
        if (parseInt(paramValues) === configDistanceLimit) {
          return;
        }
      }

      // tag, time_slots, duration
      if (Array.isArray(paramValues) && paramValues.length > 0) {
        paramValues.forEach((value) => {
          updateFilterObject(filterObject, value);
        });
        return;
      }

      // category
      if (
        typeof paramValues === 'string' &&
        paramValues.split(',').length > 1
      ) {
        const values = paramValues.split(',');
        values.forEach((value) => {
          updateFilterObject(filterObject, value);
        });
        return;
      }

      updateFilterObject(filterObject, paramValues);
    });
  });

  const removeFilter = (filter) => {
    const proceed = () => {
      const valueToRemove = filter.value.toString();

      const removeCategoryFilter = () => {
        let values = params[filter.key].split(',');
        if (values.length > 1) {
          values = values.filter((value) => value !== valueToRemove);
          params[filter.key] = values.join(',');
        } else {
          delete params[filter.key];
        }
      };

      if (filter.key === 'category') {
        removeCategoryFilter();
      } else if (['participants', 'price_span', 'min_age'].includes(filter.key)) {
        delete params[filter.key];
      } else if (filter.key === 'distance') {
        params[filter.key] = configDistanceLimit;
      } else {
        const index = params[filter.key].indexOf(valueToRemove);
        if (index !== -1) {
          params[filter.key].splice(index, 1);
        }
      }

      const currentHash = window.location.hash;
      history.push({
        pathname: window.location.pathname,
        search: qs.stringify({ ...params }),
        hash: currentHash
      });
    };

    if (typeof flashSkeletons === 'function') {
      flashSkeletons().then(proceed);
    } else {
      proceed();
    }
  };

  const [maxFiveFilters, setMaxFiveFilters] = useState(false);

  useEffect(() => {
    if (filtersData.length > 5) {
      setMaxFiveFilters(true);
    } else {
      setMaxFiveFilters(false);
    }
  }, [filtersData.length]);

  const activeFilters = filtersData.map((filter, index) => {
    return (
      <div
        key={index}
        className="selected-filters__item d-flex overflow-hidden"
        style={{ display: maxFiveFilters && index > 4 ? 'none' : '' }}
      >
        <Button
          classNames="flex-0-1-auto"
          label={<Typography variant="p3">{filter.title}</Typography>}
          style={ButtonStyles.chipSuggestionSelected}
          size={ButtonSizes.xs}
          onClick={() => removeFilter(filter)}
          iconRight={
            <BetaIcon
              classNames="flex-1-0-auto"
              name={'close'}
              size={IconSizes[6]}
            />
          }
        />
      </div>
    );
  });

  return (
    <div className="selected-filters--container d-flex flex-column gap-3xs">
      {activeFilters.length === 0 && (
        <div className="selected-filters__label">
          {TRANSLATIONS.NO_FILTERS_SELECTED}
        </div>
      )}
      {activeFilters.length > 0 && (
        <div className="selected-filters__items d-flex flex-row flex-wrap gap-3xs">
          {activeFilters}
        </div>
      )}
      {dateSpanString && (
        <div
          key={'date-filter'}
          className="selected-filters__item d-flex overflow-hidden"
        >
          <Button
            classNames="flex-0-1-auto"
            label={<Typography variant="p3">{dateSpanString}</Typography>}
            style={ButtonStyles.chipSuggestionSelected}
            size={ButtonSizes.xs}
            onClick={() => {
              const updatedParams = { ...params };
              delete updatedParams.startDate;
              delete updatedParams.endDate;
              delete updatedParams.isAlways;
              delete updatedParams.isNextMonth;
              history.push(`?${qs.stringify(updatedParams)}`);
            }}
            iconRight={
              <BetaIcon
                classNames="flex-1-0-auto"
                name={'close'}
                size={IconSizes[6]}
              />
            }
          />
        </div>
      )}
      <div className="selected-filters__cta-wrapper">
        {filtersData.length > 5 && (
          <div className="selected-filters__show-more">
            <Button
              classNames="pl-none pr-none"
              label={
                maxFiveFilters ? TRANSLATIONS.SHOW_ALL : TRANSLATIONS.SHOW_LESS
              }
              style={ButtonStyles.text}
              iconRight={
                <Icon
                  icon={maxFiveFilters ? iconChevronDown : iconChevronUp}
                  className="icon"
                />
              }
              onClick={() => setMaxFiveFilters(!maxFiveFilters)}
            />
          </div>
        )}
        {activeFilters.length > 1 && (
          <div className="selected-filters__reset-button">
            <Button
              classNames="pl-none pr-none"
              label={TRANSLATIONS.REMOVE_FILTERS}
              style={ButtonStyles.textDestructive}
              iconLeft={
                <Image
                  source="https://cdn.freedome.it/icons/bin-red.svg"
                  size={ImageSizes.original}
                  alt="Bin"
                />
              }
              onClick={() => resetFilters()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

AllFiltersSelectedFilter.propTypes = {
  params: PropTypes.object,
  history: PropTypes.object,
  filtersKeys: PropTypes.arrayOf(PropTypes.node),
  resetFilters: PropTypes.func,
  tags: PropTypes.array,
  categories: PropTypes.array,
  flashSkeletons: PropTypes.func,
};

export default AllFiltersSelectedFilter;
